var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 83 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_206297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.9681 61.2481H0.324341V10.7436H15.8309L25.9664 0.95459H35.972V37.6851H47.1904V0.95459H57.0228L69.5406 10.7436H82.8814V61.2481H82.9681ZM6.82149 54.751H76.4709V17.2408H67.3316L54.8137 7.45174H53.7309V44.1823H29.4749V7.45174H28.5653L18.4297 17.2408H6.82149V54.751Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_206297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6437,
    height: 60.2935,
    fill: "white",
    transform: "translate(0.324463 0.955078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBore);
export default __webpack_public_path__ + "static/media/bore.a0ba829278d7fcc4a1b5e2d69ad80927.svg";
export { ForwardRef as ReactComponent };